"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Area = _interopRequireDefault(require("../algorithm/Area"));

var _Geometry2 = _interopRequireDefault(require("./Geometry"));

var _Arrays = _interopRequireDefault(require("../../../../java/util/Arrays"));

var _CoordinateFilter = _interopRequireDefault(require("./CoordinateFilter"));

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

var _Orientation = _interopRequireDefault(require("../algorithm/Orientation"));

var _System = _interopRequireDefault(require("../../../../java/lang/System"));

var _GeometryComponentFilter = _interopRequireDefault(require("./GeometryComponentFilter"));

var _CoordinateArrays = _interopRequireDefault(require("./CoordinateArrays"));

var _Polygonal = _interopRequireDefault(require("./Polygonal"));

var _GeometryFilter = _interopRequireDefault(require("./GeometryFilter"));

var _CoordinateSequenceFilter = _interopRequireDefault(require("./CoordinateSequenceFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Polygon =
/*#__PURE__*/
function (_Geometry) {
  _inherits(Polygon, _Geometry);

  function Polygon() {
    var _this;

    _classCallCheck(this, Polygon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Polygon).call(this));
    Polygon.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(Polygon, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      return this._shell.getEnvelopeInternal();
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      if (this.isEmpty()) {
        return [];
      }

      var coordinates = new Array(this.getNumPoints()).fill(null);
      var k = -1;

      var shellCoordinates = this._shell.getCoordinates();

      for (var x = 0; x < shellCoordinates.length; x++) {
        k++;
        coordinates[k] = shellCoordinates[x];
      }

      for (var i = 0; i < this._holes.length; i++) {
        var childCoordinates = this._holes[i].getCoordinates();

        for (var j = 0; j < childCoordinates.length; j++) {
          k++;
          coordinates[k] = childCoordinates[j];
        }
      }

      return coordinates;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      var area = 0.0;
      area += _Area.default.ofRing(this._shell.getCoordinateSequence());

      for (var i = 0; i < this._holes.length; i++) {
        area -= _Area.default.ofRing(this._holes[i].getCoordinateSequence());
      }

      return area;
    }
  }, {
    key: "isRectangle",
    value: function isRectangle() {
      if (this.getNumInteriorRing() !== 0) return false;
      if (this._shell === null) return false;
      if (this._shell.getNumPoints() !== 5) return false;

      var seq = this._shell.getCoordinateSequence();

      var env = this.getEnvelopeInternal();

      for (var i = 0; i < 5; i++) {
        var x = seq.getX(i);
        if (!(x === env.getMinX() || x === env.getMaxX())) return false;
        var y = seq.getY(i);
        if (!(y === env.getMinY() || y === env.getMaxY())) return false;
      }

      var prevX = seq.getX(0);
      var prevY = seq.getY(0);

      for (var i = 1; i <= 4; i++) {
        var x = seq.getX(i);
        var y = seq.getY(i);
        var xChanged = x !== prevX;
        var yChanged = y !== prevY;
        if (xChanged === yChanged) return false;
        prevX = x;
        prevY = y;
      }

      return true;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === "number" && arguments[0] instanceof _Geometry2.default) {
        var other = arguments[0],
            tolerance = arguments[1];

        if (!this.isEquivalentClass(other)) {
          return false;
        }

        var otherPolygon = other;
        var thisShell = this._shell;
        var otherPolygonShell = otherPolygon._shell;

        if (!thisShell.equalsExact(otherPolygonShell, tolerance)) {
          return false;
        }

        if (this._holes.length !== otherPolygon._holes.length) {
          return false;
        }

        for (var i = 0; i < this._holes.length; i++) {
          if (!this._holes[i].equalsExact(otherPolygon._holes[i], tolerance)) {
            return false;
          }
        }

        return true;
      } else return _get(_getPrototypeOf(Polygon.prototype), "equalsExact", this).apply(this, arguments);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      if (arguments.length === 0) {
        this.normalize(this._shell, true);

        for (var i = 0; i < this._holes.length; i++) {
          this.normalize(this._holes[i], false);
        }

        _Arrays.default.sort(this._holes);
      } else if (arguments.length === 2) {
        var ring = arguments[0],
            clockwise = arguments[1];

        if (ring.isEmpty()) {
          return null;
        }

        var uniqueCoordinates = new Array(ring.getCoordinates().length - 1).fill(null);

        _System.default.arraycopy(ring.getCoordinates(), 0, uniqueCoordinates, 0, uniqueCoordinates.length);

        var minCoordinate = _CoordinateArrays.default.minCoordinate(ring.getCoordinates());

        _CoordinateArrays.default.scroll(uniqueCoordinates, minCoordinate);

        _System.default.arraycopy(uniqueCoordinates, 0, ring.getCoordinates(), 0, uniqueCoordinates.length);

        ring.getCoordinates()[uniqueCoordinates.length] = uniqueCoordinates[0];

        if (_Orientation.default.isCCW(ring.getCoordinates()) === clockwise) {
          _CoordinateArrays.default.reverse(ring.getCoordinates());
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._shell.getCoordinate();
    }
  }, {
    key: "getNumInteriorRing",
    value: function getNumInteriorRing() {
      return this._holes.length;
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return 1;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return _Geometry2.default.TYPECODE_POLYGON;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 2;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var len = 0.0;
      len += this._shell.getLength();

      for (var i = 0; i < this._holes.length; i++) {
        len += this._holes[i].getLength();
      }

      return len;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      var numPoints = this._shell.getNumPoints();

      for (var i = 0; i < this._holes.length; i++) {
        numPoints += this._holes[i].getNumPoints();
      }

      return numPoints;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var poly = this.copy();
      poly._shell = this._shell.copy().reverse();
      poly._holes = new Array(this._holes.length).fill(null);

      for (var i = 0; i < this._holes.length; i++) {
        poly._holes[i] = this._holes[i].copy().reverse();
      }

      return poly;
    }
  }, {
    key: "convexHull",
    value: function convexHull() {
      return this.getExteriorRing().convexHull();
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var thisShell = this._shell;
        var otherShell = o._shell;
        return thisShell.compareToSameClass(otherShell);
      } else if (arguments.length === 2) {
        var _o = arguments[0],
            comp = arguments[1];
        var poly = _o;
        var thisShell = this._shell;
        var otherShell = poly._shell;
        var shellComp = thisShell.compareToSameClass(otherShell, comp);
        if (shellComp !== 0) return shellComp;
        var nHole1 = this.getNumInteriorRing();
        var nHole2 = poly.getNumInteriorRing();
        var i = 0;

        while (i < nHole1 && i < nHole2) {
          var thisHole = this.getInteriorRingN(i);
          var otherHole = poly.getInteriorRingN(i);
          var holeComp = thisHole.compareToSameClass(otherHole, comp);
          if (holeComp !== 0) return holeComp;
          i++;
        }

        if (i < nHole1) return 1;
        if (i < nHole2) return -1;
        return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if ((0, _hasInterface.default)(arguments[0], _CoordinateFilter.default)) {
        var filter = arguments[0];

        this._shell.apply(filter);

        for (var i = 0; i < this._holes.length; i++) {
          this._holes[i].apply(filter);
        }
      } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequenceFilter.default)) {
        var _filter = arguments[0];

        this._shell.apply(_filter);

        if (!_filter.isDone()) {
          for (var i = 0; i < this._holes.length; i++) {
            this._holes[i].apply(_filter);

            if (_filter.isDone()) break;
          }
        }

        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if ((0, _hasInterface.default)(arguments[0], _GeometryFilter.default)) {
        var _filter2 = arguments[0];

        _filter2.filter(this);
      } else if ((0, _hasInterface.default)(arguments[0], _GeometryComponentFilter.default)) {
        var _filter3 = arguments[0];

        _filter3.filter(this);

        this._shell.apply(_filter3);

        for (var i = 0; i < this._holes.length; i++) {
          this._holes[i].apply(_filter3);
        }
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (this.isEmpty()) {
        return this.getFactory().createMultiLineString();
      }

      var rings = new Array(this._holes.length + 1).fill(null);
      rings[0] = this._shell;

      for (var i = 0; i < this._holes.length; i++) {
        rings[i + 1] = this._holes[i];
      }

      if (rings.length <= 1) return this.getFactory().createLinearRing(rings[0].getCoordinateSequence());
      return this.getFactory().createMultiLineString(rings);
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return _Geometry2.default.TYPENAME_POLYGON;
    }
  }, {
    key: "copy",
    value: function copy() {
      var shellCopy = this._shell.copy();

      var holeCopies = new Array(this._holes.length).fill(null);

      for (var i = 0; i < this._holes.length; i++) {
        holeCopies[i] = this._holes[i].copy();
      }

      return new Polygon(shellCopy, holeCopies, this._factory);
    }
  }, {
    key: "getExteriorRing",
    value: function getExteriorRing() {
      return this._shell;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._shell.isEmpty();
    }
  }, {
    key: "getInteriorRingN",
    value: function getInteriorRingN(n) {
      return this._holes[n];
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Polygon;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Polygonal.default];
    }
  }]);

  return Polygon;
}(_Geometry2.default);

exports.default = Polygon;

Polygon.constructor_ = function () {
  this._shell = null;
  this._holes = null;
  var shell = arguments[0],
      holes = arguments[1],
      factory = arguments[2];

  _Geometry2.default.constructor_.call(this, factory);

  if (shell === null) {
    shell = this.getFactory().createLinearRing();
  }

  if (holes === null) {
    holes = [];
  }

  if (_Geometry2.default.hasNullElements(holes)) {
    throw new _IllegalArgumentException.default("holes must not contain null elements");
  }

  if (shell.isEmpty() && _Geometry2.default.hasNonEmptyElements(holes)) {
    throw new _IllegalArgumentException.default("shell is empty but holes are not");
  }

  this._shell = shell;
  this._holes = holes;
};

Polygon.serialVersionUID = -3494792200821764533;